import React from 'react';
import PropTypes from 'prop-types';


export const Title = ({ title }) => {
    return (
        <h1>
            { title }
        </h1>
    );
};

Title.propTypes = {
    /* 
      title for component
    */ 
      title: PropTypes.string.isRequired,
  }
  
Title.defaultProps = {
    /*
        default value if title is not given
    */
      title: '',
}